

export const list = [

	{
		prop: 'bubbles',
		name: 'Bubbles',
	}
];
